import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-removed-users',
  templateUrl: './removed-users.component.html',
  styleUrls: ['./removed-users.component.css']
})
export class RemovedUsersComponent implements OnInit {

  public api = api;
  public env = environment;
  public data: any;
  public user: any;
  private subs: Subscription[] = [];
  public search: any = '';

  constructor(public service: WebserviceService,
    private _message: MessageService,
    public router: Router,
    private _common: CommonService,
    private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : {};
    this.getData('');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(url: any, e: any = '') {
    // console.log(e);
    let key: any = (this.actRoute.snapshot.paramMap.get('key')) ? this.actRoute.snapshot.paramMap.get('key') : e;
    let uid: any = (this.actRoute.snapshot.paramMap.get('uid')) ? this.actRoute.snapshot.paramMap.get('uid') : this.user.id;
    let apiUrl = '';
    apiUrl = url == '' ? `${this.env.baseUrl + this.api.user + this.api.removeChild}/${uid}${(key && key.length > 2) ? '/' + key : ''}` : url;

    const sub1 = this.getServices().Get(apiUrl).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res.data;
          console.log(this.data);

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  undoRemove(e: any) {
    const sub2 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${e?.id}${this.api.undoRemoveUser}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.getData('');
          this._message.errmessage(res?.data?.message);
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
          }
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub2)
  }

  confirmBox(item: any) {
    Swal.fire({
      title: 'ARE YOU SURE?',
      text: 'User will be un-removed!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancle'
    }).then((result) => {
      if (result.value) {
        this.undoRemove(item);
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
